import React from 'react';
import styled from 'styled-components';
import { func, object, string } from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Icon from '@material-ui/core/Icon';
import {
  defaultTheme,
  ThemeProvider
} from '@material-dev/thread';
import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import theme from 'admin/muiTheme';

const formColors = {
  text: {
    main: theme.palette.primary.light,
    placeholder: 'rgba(0,0,0,0.38)'
  },
  borders: {
    main: 'rgba(0, 0, 0, 0.12)'
  }
};

const styles = () => ({
  formControl: {
    'label + &': {
      marginTop: '0'
    },
    '&:before, &:after': {
      zIndex: '2'
    },
    '&:before': {
      borderColor: formColors.borders.main
    },
    '&:hover:before': {
      borderColor: `${formColors.borders.main} !important`,
      borderWidth: '0 0 1px 0 !important'
    }
  },
  select: {
    paddingBottom: '5px',
    '&:focus': {
      background: '#fff'
    }
  },
  // FormHelperText root
  root: {
    marginTop: '0',
    paddingBottom: '0'
  }
});

const ErrorText = styled.span`
  padding-left: 4px
`;

const MuiNativeSelect = (props) => {
  const {
    autoComplete,
    classes,
    error,
    handleSelectBlur,
    handleSelectChange,
    id,
    label,
    options,
    placeholder,
    type,
    value
  } = props;

  const fieldName = placeholder.toLowerCase().replace(' ', '-');

  const hasErrors = Object.values(error).find(res => res);

  return (
    <MuiThemeProvider theme={theme}>
      <ThemeProvider theme={defaultTheme}>
        <FormControl
          className={`${id}__${fieldName}-select`}
          error={hasErrors}
          style={{
            width: '100%',
            minHeight: '58px'
          }}
        >
          {label &&
            <InputLabel
              className={`${id}__label ${id}__label--md-override`}
              htmlFor={`${id}-${fieldName}`}
              id={`${id}-label`}
              shrink
              style={{
                opacity: value ? '1' : '0',
                paddingLeft: '0',
                top: '-19px'
              }}
            >
              {label}
            </InputLabel>
          }
          <NativeSelect
            classes={{
              select: classes.select
            }}
            input={<Input
              classes={{ formControl: classes.formControl }}
              id={`${id}-${fieldName}`}
              name={fieldName}
              autoComplete={`${id}-${fieldName} ${autoComplete}`}
              onBlur={() => handleSelectBlur(type)}
            />}
            onChange={handleSelectChange(type)}
            style={{
              color: value ? formColors.text.main : formColors.text.placeholder
            }}
            value={value || ''}
          >
            <option value="" disabled>{placeholder}</option>
            {options && Object.keys(options).map(key => <option key={key} value={key}>{options[key]}</option>)}
          </NativeSelect>
          {hasErrors &&
            <FormHelperText
              classes={{
                root: classes.root
              }}
            >
              <Icon style={{
                fontSize: '16px',
                verticalAlign: 'middle'
              }}>warning</Icon>
              <ErrorText>{error.required &&
                `${placeholder} is required`}
              </ErrorText>
            </FormHelperText>
          }
        </FormControl>
      </ThemeProvider>
    </MuiThemeProvider>
  );
};
MuiNativeSelect.defaultProps = {
  error: {}
};

MuiNativeSelect.propTypes = {
  autoComplete: string,
  classes: object,
  error: object,
  handleSelectBlur: func,
  handleSelectChange: func,
  id: string,
  label: string,
  options: object,
  placeholder: string,
  type: string,
  value: string
};

export default withStyles(styles)(MuiNativeSelect);



// WEBPACK FOOTER //
// ./src/app/admin/components/NativeSelect/index.js